import { useTranslation } from 'react-i18next'

import { useDeleteAccount } from '../../../../hooks/user/useDeleteAccount'

import { Card } from '../../../card/Card'
import { Button } from '../../../buttons/Button'
import FormSection from '../../../formSection/FormSection'

import { useAuth } from '../../../../contexts/AuthContext'
import { useConfirm } from '../../../../contexts/ConfirmContext'
import { useProfileContext } from '../../../../contexts/ProfileContext'
import { ConfirmLayout } from '../../../../types/confirm/confirm'
import { getFromToken, JwtKeys } from '../../../../utils/jwtUtils'

/** Permanent deletion of the account, behind a confirmation that names the account being deleted. */
const DeleteAccount = () => {
  const { t } = useTranslation('account')
  const { authInfo } = useAuth()
  const { confirm } = useConfirm()
  const { profile } = useProfileContext()
  const { deleteAccount, loading } = useDeleteAccount()
  const userEmail = getFromToken(authInfo?.accessToken ?? '', JwtKeys.EMAIL) ?? ''

  const handleDelete = () => {
    confirm({
      layout: ConfirmLayout.DETAILS,
      title: t('account.delete.title'),
      subtitle: t('account.delete.confirmation-subtitle'),
      confirmLabel: t('account.delete.confirm'),
      backLabel: t('account.delete.cancel'),
      warning: t('account.delete.subtitle'),
      allowIncompleteProfile: true,
      returnTo: '/account/delete-account',
      itemCards: [
        {
          id: profile?.id ?? 'account',
          title: t('account.delete.item'),
          details: userEmail ? [{ label: t('account.delete.email'), value: userEmail }] : undefined,
        },
      ],
      onConfirm: async () => {
        await deleteAccount()
      },
    })
  }

  return (
    <Card className="col-12 responsive-half-card">
      <FormSection title={t('account.delete.section-title')} subtitle={t('account.delete.notice')}>
        <ul className="account-delete-consequences">
          <li>{t('account.delete.consequence.data')}</li>
          <li>{t('account.delete.consequence.passes')}</li>
          <li>{t('account.delete.consequence.points')}</li>
        </ul>
        <Button
          label={t('account.delete.action')}
          variant="danger"
          size="md"
          loading={loading}
          onClick={handleDelete}
        />
      </FormSection>
    </Card>
  )
}

export default DeleteAccount
